export const populationTallyActions = {
  populatePopulationTallies: "POPULATE_POPULATION_TALLIES",
  populationTallyLoading: "POPULATION_DATA_TALLY_LOADING",
  populationTallyLoadError: "POPULATION_DATA_TALLY_LOAD_ERROR"
};
